<div class="compact-map-controller-container">
  <!-- Loading spinner (fuera del panel, arriba) -->
  @if (showLoading) {
  <div class="loading-spinner-wrapper">
    <mat-spinner diameter="30"></mat-spinner>
  </div>
  }

  <!-- Panel principal con botones -->
  <div class="compact-controller-panel">
    <!-- Zoom In button -->
    <div matTooltip="Zoom In" matTooltipPosition="left">
      <button matMiniFab [disabled]="lockZoomIn" (click)="zoomIn()">
        <mat-icon>add</mat-icon>
      </button>
    </div>

    <!-- Zoom Out button -->
    <div matTooltip="Zoom Out" matTooltipPosition="left">
      <button matMiniFab [disabled]="lockZoomOut" (click)="zoomOut()">
        <mat-icon>remove</mat-icon>
      </button>
    </div>

    <!-- Vertical button (solo visible en modo 3D) -->


    <!-- Compass button (último botón del panel) con wrapper relativo -->
    <div class="compass-button-container">
      <button
        matMiniFab
        class="compass-center-button"
        (mouseenter)="onCompassHover(true)"
        >
        <mat-icon [style.transform]="'rotate(' + controllerRotation + 'deg)'">navigation</mat-icon>
      </button>
        @if (compassHovered) {
          <!-- SVG compass hover overlay (position absolute, centrado en el botón) -->
          <div class="compass-wrapper" (mouseleave)="onCompassHover(false)">

            <!-- Modern Compass SVG (botón unificado que rota) -->
            <svg viewBox="0 0 100 100" class="compass-svg">
              
              <defs>
                <!-- Máscara para crear el anillo (donut) con agujero transparente -->
                <mask id="donut-mask">
                  <!-- Todo blanco = visible -->
                  <rect x="-40" y="-40" width="80" height="80" rx="8" fill="white"/>
                  <!-- Agujero negro = transparente -->
                  <rect x="-15" y="-15" width="30" height="30" rx="8" fill="black"/>
                </mask>
              </defs>
              
              <!-- Centro del SVG en (50, 50) -->
              <g transform="translate(50, 50)">
                
                <!-- Grupo principal que ROTA según orientación seleccionada -->
                <g class="rotation-group" [attr.transform]="'rotate(' + controllerRotation + ')'">
                  
                  <!-- Background del anillo (donut) con máscara -->
                  <rect x="-40" y="-40" width="80" height="80" 
                        mask="url(#donut-mask)"
                        class="compass-background"/>
                  
                  <!-- Sección Norte (arriba, 0°) -->
                  <g class="orientation-section"
                     [class.disabled]="!getAvailableOrientations()['N']"
                     [class.active]="orientation === 'N'"
                     (click)="onModernOrientationClick('N'); $event.stopPropagation()">
                    
                    <path d="M -15,-15 L 15,-15 L 15,-40 L -15,-40 Z" 
                          class="section-area"
                          (mouseenter)="onModernSectionHover('N')"
                          (mouseleave)="onModernSectionLeave()"/>
                    
                    <text x="0" y="-28" 
                          [attr.transform]="'rotate(' + (-controllerRotation) + ' 0 -28)'"
                          class="section-text"
                          [class.hovered]="hoveredSection === 'N'"
                          text-anchor="middle"
                          dominant-baseline="middle"
                          pointer-events="none">N</text>
                  </g>
                  
                  <!-- Sección Este (derecha, 90°) -->
                  <g class="orientation-section"
                     [class.disabled]="!getAvailableOrientations()['E']"
                     [class.active]="orientation === 'E'"
                     (click)="onModernOrientationClick('E'); $event.stopPropagation()">
                    
                    <path d="M 15,-15 L 40,-15 L 40,15 L 15,15 Z" 
                          class="section-area"
                          (mouseenter)="onModernSectionHover('E')"
                          (mouseleave)="onModernSectionLeave()"/>
                    
                    <text x="28" y="0" 
                          [attr.transform]="'rotate(' + (-controllerRotation) + ' 28 0)'"
                          class="section-text"
                          [class.hovered]="hoveredSection === 'E'"
                          text-anchor="middle"
                          dominant-baseline="middle"
                          pointer-events="none">E</text>
                  </g>
                  
                  <!-- Sección Sur (abajo, 180°) -->
                  <g class="orientation-section"
                     [class.disabled]="!getAvailableOrientations()['S']"
                     [class.active]="orientation === 'S'"
                     (click)="onModernOrientationClick('S'); $event.stopPropagation()">
                    
                    <path d="M -15,15 L 15,15 L 15,40 L -15,40 Z" 
                          class="section-area"
                          (mouseenter)="onModernSectionHover('S')"
                          (mouseleave)="onModernSectionLeave()"/>
                    
                    <text x="0" y="28" 
                          [attr.transform]="'rotate(' + (-controllerRotation) + ' 0 28)'"
                          class="section-text"
                          [class.hovered]="hoveredSection === 'S'"
                          text-anchor="middle"
                          dominant-baseline="middle"
                          pointer-events="none">S</text>
                  </g>
                  
                  <!-- Sección Oeste (izquierda, 270°) -->
                  <g class="orientation-section"
                     [class.disabled]="!getAvailableOrientations()['W']"
                     [class.active]="orientation === 'W'"
                     (click)="onModernOrientationClick('W'); $event.stopPropagation()">
                    
                    <path d="M -40,-15 L -15,-15 L -15,15 L -40,15 Z" 
                          class="section-area"
                          (mouseenter)="onModernSectionHover('W')"
                          (mouseleave)="onModernSectionLeave()"/>
                    
                    <text x="-28" y="0" 
                          [attr.transform]="'rotate(' + (-controllerRotation) + ' -28 0)'"
                          class="section-text"
                          [class.hovered]="hoveredSection === 'W'"
                          text-anchor="middle"
                          dominant-baseline="middle"
                          pointer-events="none">W</text>
                  </g>
                </g>
              </g>
            </svg>
          </div>
        }
    </div>

<!--    @if((flagService.getFlags$() | async)?.[FeatureFlags.INFRARED] ){-->
        @if(!is3D){
            <div matTooltip="{{ enableInfraredButton ? '' : 'CIR imagery not available' }}" matTooltipPosition="left">
              <button
                matMiniFab
                class="control-button cir-button mat-icon-toggle"
                [disabled]="!enableInfraredButton"
                [class.selected]="viewerService.infraredStatus$ | async"
                (click)="toggleInfrared()"
                id="infrared-over-button">
                CIR
              </button>
            </div>
        }@else {
                <div matTooltip="Vertical View" matTooltipPosition="left">
                  <button matMiniFab [disabled]="!enableNadirButton()" (click)="loadNadirImage()">
                    V
                  </button>
                </div>

            @if(showInfraredButton3D){
                <div matTooltip="{{ enableInfraredButton ? 'Vertical CIR imagery' : 'Vertical CIR imagery not available' }}" matTooltipPosition="left">
                  <button
                    matMiniFab
                    [disabled]="!enableInfraredButton"
                    type="button"
                    class="control-button cir-button mat-icon-toggle"
                    [class.selected]="orientation === 'I'"
                    (click)="loadInfraredImage()"
                    id="infrared-over-button">
                    CIR
                  </button>
                </div>
            }

        }
<!--    }-->

    <!-- 2D/3D toggle button -->
    <div [matTooltip]="get3DModeMessage() || ''" matTooltipPosition="left">
      <button
        matMiniFab
        (click)="changeMode()"
        [disabled]="!enable3DButton()">
        {{ is3D ? "2D" : "3D" }}
      </button>
    </div>

    <!-- Layer Management Button with Overlay Panel -->
    <button
      matMiniFab
      matTooltip="Layers"
      matTooltipPosition="left"
      (click)="toggleLayerPanel()"
      [class.selected]="layerPanelOpen"
      cdkOverlayOrigin
      #layerTrigger="cdkOverlayOrigin">
      <mat-icon>layers</mat-icon>
    </button>

    <!-- AI Chat Button with Overlay Panel -->
    <button
      matMiniFab
      matTooltip="AI Assistant"
      matTooltipPosition="left"
      [hidden]="!agents.length"
      (click)="toggleChatPanel()"
      [class.selected]="chatPanelOpen"
      cdkOverlayOrigin
      #chatTrigger="cdkOverlayOrigin">
      <mat-icon>smart_toy</mat-icon>
    </button>
  </div>
</div>

<!-- Chat Panel Overlay -->
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="chatTrigger"
  [cdkConnectedOverlayOpen]="chatPanelOpen"
  [cdkConnectedOverlayPositions]="chatPanelPositions"
  (detach)="chatPanelOpen = false">
  <div class="chat-overlay-panel d-flex flex-column"
       cdkDrag cdkDragRootElement=".cdk-overlay-pane"
       libChatOverlayResize #chatResize="libChatOverlayResize">
    <div class="chat-resize-handle chat-resize-nw" (mousedown)="chatResize.onResizeStart($event, 'nw')" aria-label="Resize from top-left"></div>
    <div class="chat-resize-handle chat-resize-ne" (mousedown)="chatResize.onResizeStart($event, 'ne')" aria-label="Resize from top-right"></div>
    <div class="chat-resize-handle chat-resize-sw" (mousedown)="chatResize.onResizeStart($event, 'sw')" aria-label="Resize from bottom-left"></div>
    <div class="chat-resize-handle chat-resize-se" (mousedown)="chatResize.onResizeStart($event, 'se')" aria-label="Resize from bottom-right"></div>
    <lib-chat-panel-hdr
      cdkDragHandle
      [title]="activeAgent()?.label ?? 'AI Assistant'"
      [agents]="agents"
      [selectedAgentId]="selectedAgentId() ?? ''"
      [showMinimize]="true"
      [showReset]="chatResize.isDirty()"
      (agentChange)="onAgentChange($event)"
      (newChatRequested)="startNewChat()"
      (minimizeClicked)="chatPanelOpen = false"
      (resetClicked)="chatResize.reset()" />
    @if (activeAgent()) {
      <lib-chat-container class="flex-fill" [agentId]="activeAgent()!.id" [idleConfig]="activeAgent()!.idleState" [threadId]="currentThreadId()" />
    }
  </div>
</ng-template>

<!-- Layer Panel Overlay -->
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="layerTrigger"
  [cdkConnectedOverlayOpen]="layerPanelOpen"
  [cdkConnectedOverlayPositions]="layerPanelPositions"
  (detach)="layerPanelOpen = false">
  
  <app-layer-overlay-panel
    [isImageryShown]="isImageryShown"
    [overlayLayers]="viewerService.overlayLayers$ | async"
    [centerAOI]="(viewerService.projectStatus$ | async)?.centerAOI"
    [isActivatedAutoContrast]="viewerService.enableContrast$ | async"
    [autoContrastAllowed]="autoContrastAllowed"
    [resize]="false"
    [dualViewEnabled]="false"
    (imageryToggle)="onImageryToggle()"
    (basemapToggle)="onBasemapToggle()"
    (contrastToggle)="onContrastToggle()"
    (overlayOrderChange)="onOverlayOrderChange($event)"
    (layerVisibilityChange)="onLayerVisibilityChange($event)"
    (childVisibilityChange)="onChildVisibilityChange($event)"
    (featureFit)="onFeatureFit($event)"
    (bboxFit)="onBboxFit($event)"
    (layerRemove)="onLayerRemove($event)">
  </app-layer-overlay-panel>
</ng-template>
